import styled, {keyframes} from 'styled-components';
import {MAIN_COLOR} from "../../components/globalThemes";
import {Link} from "react-router-dom";

export const VideoContainer = styled.div`
    position: relative;
    overflow: hidden;
`;

export const StyledVideo = styled.video`
    height: 100%;
    width: 100%;
    filter: brightness(50%);
    background-color: black;
    
    @media (max-width: 720px) {
        width: inherit;
        height: 500px;
    }
`;

export const StyledSource = styled.source``;

export const StyledVideoFront = styled.div`
    background: repeating-linear-gradient(
        to bottom,
        #29262190,
        #29262190 2px,
        #33302a90 2px,
        #33302a90 4px); 
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
`;

export const VideoFlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;  
    z-index: 1;
    
    @media (max-width: 1280px) {
        transform: scale(0.9);  
    }
    
    @media (max-width: 1000px) {
        transform: scale(0.75); 
    }
    
    @media (max-width: 900px) {
        transform: scale(0.6);
    }
`;

export const IntroImgTitle = styled.div`
    display: flex;
    margin-top: 120px;
    
    @media (max-width: 1280px) {
        margin-top: 0;
    }
    
    @media (max-width: 900px) {
        margin-top: -50px;
    }
`;

export const Title = styled.span`
    font-family: Roboto Condensed, serif;
    font-size: 35px;
    color: white;
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 20px;
`;

export const Subtitle = styled.span`
    font-family: Caveat, serif;
    font-size: 20px;
    font-weight: 300;
    color: white;
    margin: 0;
`;

export const Desc = styled.p`
    font-family: Lato, serif;
    font-size: 17px;
    color: #C0C0C0;
    white-space: pre-wrap;
    text-align: center;
    line-height: 1.5;
    transition: 1s all;
    text-shadow: 2px 2px black;
    
    &:hover {
        color: white;
    }
`;

const showSubtitles = () => keyframes`
    0% {
        content: "SPORT...";
        opacity: 0;
    }

    7% {
        content: "SPORT...";
        opacity: 1;
    }

    14% {
        content: "SPORT...";
        opacity: 0;
    }

    21% {
        content: "PASJA...";
        opacity: 0;
    }

    28% {
        content: "PASJA...";
        opacity: 1;
    }

    35% {
        content: "PASJA...";
        opacity: 0;
    }

    42% {
        content: "DETERMINACJA...";
        opacity: 0;
    }

    49% {
        content: "DETERMINACJA...";
        opacity: 1;
    }

    56% {
        content: "DETERMINACJA...";
        opacity: 0;
    }

    63% {
        content: "POŚWIĘCENIE...";
        opacity: 0;
    }

    70% {
        content: "POŚWIĘCENIE...";
        opacity: 1;
    }

    77% {
        content: "POŚWIĘCENIE...";
        opacity: 0;
    }

    84% {
        content: "... FUTBOL";
        opacity: 0;
    }

    91% {
        content: "... FUTBOL";
        opacity: 1;
    }

    100% {
        content: "... FUTBOL";
        opacity: 0;
    }
`;


export const SubtitleWord = styled.p`
    font-size: 20px;
    font-family: BlenderProBold, serif; 
    color: silver;
    text-shadow: 2px 2px black;
    letter-spacing: 4px;
    height: 15px;
    margin-top: 50px;
    
    &:before {
        content: "";
        animation: ${({subtitles}) => showSubtitles(subtitles)} 25s infinite ease-in-out;
        animation-delay: 3s;
    }
`;

export const IntroQuote = styled.div`
    width: 340px;
    height: 70px;
    border: 1px solid ${MAIN_COLOR};   
    margin-top: 80px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const IntroQuoteText = styled.p`
    font-family: Lato, serif;
    font-size: 13px;
    color: white;
    font-weight: 300;
    margin: 15px;
    line-height: 1.7;
`;

export const ColoredAnchor = styled.a`
    color: ${({color}) => color};
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
    
    &:hover {
        text-decoration: underline;
    }
`;

export const ColoredLink = styled(Link)`
    color: ${({color}) => color};
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
    
    &:hover {
        text-decoration: underline;
    }
`
